import { useEffect, useState } from 'react';
import { formatUTC } from '@/utils/func';
import { useAttendanceReport } from '@/hooks/app';
import { Flex, LogTable } from '@/components/common';
import { useTranslation } from 'react-i18next';
import { ColumnBuilder } from '@/utils';

export interface AttendanceReportDesktopProps extends ReturnType<typeof useAttendanceReport> {
  startDate: string;
  endDate: string;
}

function AttendanceReportDesktop({
  items,
  loading,
  startDate,
  endDate,
  total,
  fetchReport
}: AttendanceReportDesktopProps) {

  const [t] = useTranslation(['common', 'dormitory']);

  const columns = ColumnBuilder.create([
    { key: 'type', title: t('common:labels.type') },
    { key: 'dormitoryName', title: t('dormitory:labels.address'), align: 'center' },
    { key: 'blockName', title: t('dormitory:labels.block'), align: 'center' },
    { key: 'date', title: t('common:labels.time'), align: 'center' },
  ]).build();

  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    fetchReport(page, 10, startDate, endDate);
  }, [fetchReport, startDate, endDate, page]);

  const rows = items.map((item) => ({
    ...item,
    type: item.attendanceType < 0 ? t('common:labels.entry') : t('common:labels.exit'),
    date: <div className="ltr">{formatUTC(item.attendanceDate)}</div>
  }));

  return (
    <Flex direction="column">
      <LogTable
        size="small"
        rows={rows}
        className="no-last-th-border"
        columns={columns as any}
        loading={loading}
        pagination={{
          total: total,
          current: page + 1,
          pageSize: 10,
          onChange: page => setPage(page - 1),
          showSizeChanger: false,
        }}
      />
    </Flex>
  );
}

export default AttendanceReportDesktop;
